export default {
  applicationsLoadingState(state) {
    return state.loading;
  },
  applicationsListState(state) {
    return state.list || [];
  },
  applicationsMetaState(state) {
    return state.meta || {};
  },
  applicationsErrorState(state) {
    return state.error;
  },
  createApplicationLoadingState(state) {
    return state.createLoading;
  },
  createPreApplicationLoadingState(context) {
    return context.createPreApplicationLoading;
  }
};
